<template>

  <el-dialog title="编辑" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :label-width="formLabelWidth">
      <el-form-item label="选择商品" prop="product_id">
         <template>
           <!-- <div>
             <el-button icon="el-icon-plus" @click.stop="$parent.openProduct(form.product,false)">选择产品</el-button>
           </div> -->

           <table v-if="form.product_id" border cellspacing="0" class="mt10" style="width: 500px;">
             <tr>
               <th class="tc">产品名称</th>
               <!-- <th class="w150">产品图片</th> -->
               <th class="w150 tc">产品价格</th>
             </tr>
             <tr>
               <td class="tc">
                 <div class="product-info" style="display: flex;align-items: center;text-align: left;padding: 10px;">
                   <div class="pic"><img v-img-url="form.product.image[0]?form.product.image[0].file_path:error_img" alt="" style="width: 50px;height: 50px;" /></div>
                   <div class="info">
                     <div class="name" style="padding-left: 10px;">{{ form.product.product_name }}</div>
                   </div>
                 </div>
               </td>
               <!-- <td class="tc">{{form.product.product_name}}</td> -->
               <td class="tc">{{form.product.product_price}}</td>
             </tr>
           </table>
        </template>
      <!--组件样式-->
      </el-form-item>
      <el-form-item label="是否独立奖励设置：">
        <el-radio-group v-model="form.is_single_award">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="每层奖励：" prop="single_award" v-if="form.is_single_award==1" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.single_award" type="number" :min="0" :max="100" placeholder="请输入奖励" class="max-w460"><template slot="append">%</template></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-radio-group v-model="form.status">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import QueuerebateApi from '@/api/queuerebate.js';
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['open','form','gradeList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    },
  },
  created() {

  },
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = {};
      params.id = self.form.id;
      params.product_id = self.form.product_id;
      params.is_single_award = self.form.is_single_award;
      params.single_award = self.form.single_award;
      params.status = self.form.status;
      QueuerebateApi.editProduct(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    },

  }
};
</script>

<style>
  .w150{
    width: 150px;
    border-collapse: collapse;
  }
  .tc{
    text-align: center;
    border-collapse: collapse;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/queuerebate/product/dialog/Edit.vue